import type { z } from 'zod';

export type FieldErrors = Record<string, string>;

/** Flattens zod issues into `{ 'admin.email': 'message' }` keeping the first message per field. */
export function toFieldErrors(error: z.ZodError): FieldErrors {
  const out: FieldErrors = {};
  for (const issue of error.issues) {
    const key = issue.path.map(String).join('.') || '_form';
    if (!(key in out)) out[key] = issue.message;
  }
  return out;
}
